/* hs-eslint ignored failing-rules */

/* eslint-disable hubspot-dev/no-unnamed-components */
'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import BreakdownScoreContainer from '../BreakdownScoreContainer';
import ResultSection from '../result/ResultSection';
import RadialProgressBar from '../RadialProgressBar';
import OverallData from '../../data/components/OverallData';
import OverallResultSection from '../result/OverallResultSection';
export default (({
  websiteGrade,
  ctaSection
}) => {
  const url = websiteGrade.domain;
  const grade = websiteGrade.overallGrade;
  const overallData = new OverallData().init(grade);
  const gradeType = overallData.gradeType;
  return /*#__PURE__*/_jsx("div", {
    className: "sidepanel-overall-grade",
    children: /*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsxs(ResultSection, {
        gradeType: gradeType,
        children: [/*#__PURE__*/_jsx(RadialProgressBar, {
          score: grade,
          children: grade
        }), /*#__PURE__*/_jsx("div", {
          className: "website-url",
          children: url
        }), /*#__PURE__*/_jsx("div", {
          className: "side-panel-result-section",
          children: /*#__PURE__*/_jsx(OverallResultSection, {
            websiteGrade: websiteGrade
          })
        }), /*#__PURE__*/_jsx(BreakdownScoreContainer, {
          websiteGrade: websiteGrade
        }), ctaSection]
      })
    })
  });
});